import React, { Component } from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import Home from 'react-icons/lib/fa/home';

import Lighthouse1 from './../assets/img/projects/lighthouse-1.jpg';
import Lighthouse4 from './../assets/img/projects/lighthouse-4.jpg';
import Lighthouse3 from './../assets/img/projects/lighthouse-3.jpg';

let simpleParallax;

class LightHouseProject extends Component {
  componentDidMount() {
    const hamburger = document.querySelector('.nav-hamburger');
    hamburger.style.display = 'none';

    simpleParallax = require('simple-parallax-js');
    const lighthouseImages = document.querySelectorAll('.lighthouse-img');
    new simpleParallax(lighthouseImages, { scale: 1.1 });
  }

  componentWillUnmount() {
    const hamburger = document.querySelector('.nav-hamburger');
    hamburger.style.display = 'block';
  }

  render() {
    return (
      <div className="project-page">
        <Helmet
            title="Lighthouse Project | Maslow Development Inc."
            meta={[
              { name: 'description', content: 'We co-design & develop real estate and community ecosystems.' },
              { name: 'keywords', content: 'maslow, maslow development, maslow development inc, real estate, community development, community developer, community planner, real estate development, real estate developer, real estate design, real estate designer' }
            ]}
        />

        <Link to='/#highlighted-projects' className='project-page-link-home'>
            ←<Home className='link-home-icon' />
        </Link>

        <h6 className='project-page-label'>Highlighted Project</h6>
        <h1 className='project-page-title'>Lighthouse Project</h1>
        <h5 className='project-page-blurb'>Building Holistic Ecosystems Anchored By Learning</h5>

        <section className='project-page-hero'>
            <img src={Lighthouse1} className='project-page-hero-image lighthouse-img' alt='Lighthouse Project' />

            <div className='project-page-details'>
                <p className='project-page-detail'>
                    <strong>Challenge</strong>
                    How might we bridge the divide between the haves and have-nots in persistently siloed and inequitable urban environments?
                </p>
                <p className='project-page-detail'>
                    <strong>Solution</strong>
                    A 15 acre mixed-use development in the urban core that includes a K-12 school, mixed-income housing, health & wellness facilities, and workforce development opportunities.
                </p>
                <p className='project-page-detail'>
                    <strong>Team</strong>
                    Maslow Development Inc.
                </p>
            </div>
        </section>

        <img src={Lighthouse4} className='project-page-full-image lighthouse-img' alt='Lighthouse Project' />

        <h3 className='project-page-quote'>
            How do we make sure that community members feel like they are part of the disruption and not the ones being disrupted.
            <span>— Nora Jendoubi, Partner, Maslow Development Inc.</span>
        </h3>

        <img src={Lighthouse3} className='project-page-full-image lighthouse-img' alt='Lighthouse Project' />

        <p className='project-page-link-out'>
            If you want to nerd out, take a look at our June 2019 Congress for New Urbanism presentation:
            <a href='https://bit.ly/2YIDizx' target='_blank'>
                Co-Designing Communities: Community Development with a Human-Centered Lens
            </a>
        </p>
      </div>
    );
  }
}

export default LightHouseProject;



// WEBPACK FOOTER //
// ./src/pages/lighthouse-project.js